/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DurationUnit = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type DurationUnit = typeof DurationUnit[keyof typeof DurationUnit];


export function instanceOfDurationUnit(value: any): boolean {
    for (const key in DurationUnit) {
        if (Object.prototype.hasOwnProperty.call(DurationUnit, key)) {
            // @ts-ignore
            if (DurationUnit[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DurationUnitFromJSON(json: any): DurationUnit {
    return DurationUnitFromJSONTyped(json, false);
}

export function DurationUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationUnit {
    return json as DurationUnit;
}

export function DurationUnitToJSON(value?: DurationUnit | null): any {
    return value as any;
}

